module.exports = __webpack_public_path__ + "img/last-winner-header-bg.035f78e4.png";